import { Box, Group, Text } from '@ekhodealer/ekho-common/rev';

import { Sparkle16 } from '@common/components/icons/Sparkle16';

import './SenderAvatar.scss';

type SenderType = 'lead' | 'ai_agent';

const LEAD_BACKGROUND = 'color-mix(in oklch, var(--rev-color-textPrimary) 5%, transparent)';
const AI_BACKGROUND = 'var(--rev-color-infoLight)';
interface SenderAvatarProps {
	senderType: SenderType;
	senderName: string;
}

function getInitials(name: string): string {
	return name
		.trim()
		.split(/\s+/)
		.slice(0, 2)
		.map((part) => part.charAt(0).toUpperCase())
		.join('');
}

const LeadAvatar = ({ name }: { name: string }): React.ReactNode => (
	<Box rounding='full' customBackground={LEAD_BACKGROUND}>
		<Group
			itemsAlignX='center'
			itemsAlignY='center'
			className='sender-avatar'
			ariaLabel={name}>
			<Text size='footnote' weight='semibold'>
				{getInitials(name)}
			</Text>
		</Group>
	</Box>
);

const AiAvatar = (): React.ReactNode => (
	<Box rounding='full' customBackground={AI_BACKGROUND}>
		<Group
			itemsAlignX='center'
			itemsAlignY='center'
			className='sender-avatar sender-avatar--ai'
			ariaLabel='AI Agent'>
			<Sparkle16 />
		</Group>
	</Box>
);

export const SenderAvatar = ({ senderType, senderName }: SenderAvatarProps): React.ReactNode => {
	return senderType === 'ai_agent' ? <AiAvatar /> : <LeadAvatar name={senderName} />;
};
